/* eslint-disable no-unused-vars */

import ProductBase from "@ipru-common/ProductBase";

/**
 * This file is used to store the current tenant instance.
 * @type {InstanceType<typeof import('@ipru-common/ProductBase').default>} 
 */
let CurrentProduct;

/**
 * Sets the current product instance
 * @param {ProductBase} tenant - The tenant/product instance
 */
const setCurrentProduct = (tenant) => {
  // check if current product is already set
  if (CurrentProduct) {
    console.warn("Current product is already set. Overriding it.");
  } else {
    CurrentProduct = tenant;
  }
};

export { CurrentProduct, setCurrentProduct };
